import { api } from "../../../utils/api";

export const getStockList = async () => {
  return await api.get("/inventory/stock");
};

export const getStockDetails = async (id) => {
  return await api.get(`/inventory/stock/${id}`);
};

export const getStockLedger = async (id) => {
  return await api.get(`/inventory/stock-ledger/${id}`);
};

export const getLowStock = async () => {
  return await api.get("/inventory/low-stock");
};